import { FormattedMessage, FormattedNumber } from 'react-intl';

import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { BoostSticker } from '@sorare/core/src/atoms/ui/BoostSticker';
import { useTimeLeft } from '@sorare/core/src/hooks/useTimeLeft';

type Props = {
  basisPoints: number;
  competition: string | null;
  until: Date | null;
};

const BonusDetails = ({ basisPoints, competition, until }: Props) => {
  const { message: timeLeft, isEnded } = useTimeLeft(until);

  const amount = (
    <FormattedNumber
      value={basisPoints / 10000}
      style="percent"
      signDisplay="always"
    />
  );

  return (
    <>
      {competition ? (
        <FormattedMessage
          defaultMessage="Extra {amount} score bonus in {competition}."
          values={{ amount, competition }}
        />
      ) : (
        <FormattedMessage
          defaultMessage="Extra {amount} score bonus."
          values={{ amount }}
        />
      )}
      {!!timeLeft && !isEnded && (
        <>
          {' '}
          <FormattedMessage
            defaultMessage="{timeLeft} remaining."
            values={{ timeLeft }}
          />
        </>
      )}
    </>
  );
};

export const CardSpecialEditionBonus = ({
  basisPoints,
  competition,
  until,
}: Props) => (
  <Tooltip
    title={
      <BonusDetails
        basisPoints={basisPoints}
        competition={competition}
        until={until}
      />
    }
  >
    <BoostSticker percent={basisPoints / 10000} />
  </Tooltip>
);
